import React from 'react';
import styles from './index.module.scss';

import { If } from 'utils';
import { UiKit } from 'components';
import { useStepper } from './Provider';

export default function Node({ id = null }) {
  const { direction, nodeGap, lastStepId, stepsPositionMap } = useStepper();

  const stepNumber = stepsPositionMap[id];
  const isLastStep = !!lastStepId && id === lastStepId;

  return (
    <UiKit.Flex direction={direction} align="center" gap={nodeGap}>
      <svg width="20" height="20" viewBox="0 0 20 20" className={styles.dot}>
        <circle cx="10" cy="10" r="9" className={styles.circle} />
        <path
          d="M7.3667 12.7693L3.8103 9.21287L4.52312 8.50007L7.3667 11.3436L13.477 5.2334L14.1898 5.9462L7.3667 12.7693Z"
          transform="translate(1 1)"
          className={styles.check}
        />
        <text x="10" y="11" className={styles.text}>
          {stepNumber}
        </text>
      </svg>
      <If test={!isLastStep}>
        <div className={styles.line} />
      </If>
    </UiKit.Flex>
  );
}
